var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoveUp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4026_20870",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 15
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4026_20870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.37617 12.1378C3.35534 12.1378 2.48763 11.7805 1.77305 11.0659C1.05846 10.3513 0.701172 9.48363 0.701172 8.46279C0.701172 7.44196 1.05846 6.57425 1.77305 5.85967C2.48763 5.14508 3.35534 4.78779 4.37617 4.78779H4.63867L3.89492 4.04404L4.63867 3.30029L6.65117 5.31279L4.63867 7.32529L3.89492 6.58154L4.65326 5.83779H4.37617C3.64701 5.83779 3.02721 6.093 2.5168 6.60342C2.00638 7.11383 1.75117 7.73363 1.75117 8.46279C1.75117 9.19196 2.00638 9.81175 2.5168 10.3222C3.02721 10.8326 3.64701 11.0878 4.37617 11.0878H6.65117V12.1378H4.37617ZM7.70117 7.23779V3.73779H12.6012V7.23779H7.70117ZM7.70117 12.1378V8.63779H12.6012V12.1378H7.70117ZM8.75117 11.0878H11.5512V9.68779H8.75117V11.0878Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveUp);
export default __webpack_public_path__ + "static/media/move_up.d8b1de2a4e84251807039b9b133fcb1a.svg";
export { ForwardRef as ReactComponent };